<template>
    <div id="userList">
        <el-tabs class="tab_box_self" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane class="tab_tit" label="查询某月-每日进站台次" name="first">

                <div class="search">
                    <div class="p_select select_day">
                        <div class="search_label">查询日期</div>
                        <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                            <el-date-picker v-model="startDay"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            :picker-options="pickerDayOptions"
                                            prefix-icon="''"
                                            class="datepicker"
                                            placeholder="选择开始日期">
                            </el-date-picker>
                            <i class="el-icon-date" ref="iconDateStart"></i>
                        </div>
                    </div>

                    <div class="p_select select_day">
                        <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
                            <el-date-picker v-model="endDay"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            :picker-options="pickerDayOptions"
                                            prefix-icon="''"
                                            class="datepicker"
                                            placeholder="选择结束日期">
                            </el-date-picker>
                            <i class="el-icon-date" ref="iconDateEnd"></i>
                        </div>
                    </div>

                    <div class="p_select">
                        <a class="search_btn" @click="searchData">查询</a>
                    </div>
                </div>

                <div class="table">
                    <el-table
                            :data="conditionList"
                            :height="tableHeight"
                            show-summary
                            ref="table_day"
                    >
                        <el-table-column label="日期">
                            <template slot-scope="scope">
                                {{ scope.row.dayIndex.slice(0, 4) }}-{{
                                scope.row.dayIndex.slice(4, 6)
                                }}-{{ scope.row.dayIndex.slice(6, 8) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="carCount"
                                label="进站台次"
                        ></el-table-column>
                        <el-table-column
                                prop="oilFilterBase"
                                label="机油滤芯保养基数"
                        ></el-table-column>
                        <el-table-column fixed="right" label="操作">
                            <template slot-scope="scope">
                                <a  v-if="!(scope.row.value !== '-')" @click="onClickRowButton(scope.row)"><span class="test_detail" style="border: 1px solid #29D3BF;color: #29D3BF;">录入</span></a>
                                <a  v-else @click="onClickRowButton(scope.row)" class="test_detail" size="small" style="border: 1px solid #E04066;color: #E04066;">重录</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="查询每月(录入天数/进站台次合计)" name="second">
                <div class="search">
                    <div class="p_select">
                        <a class="search_btn" @click="searchData">查询</a>
                    </div>
                </div>

                <div class="table">
                    <el-table :data="queryMonthDayCountData" :height="tableHeight" show-summary ref="table_month" >
                        <el-table-column
                                prop="key"
                                label="月份"
                        ></el-table-column>
                        <el-table-column
                                prop="value1"
                                label="录入天数"
                        ></el-table-column>
                        <el-table-column
                                prop="value2"
                                label="进站台次合计"
                        ></el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>


        <el-drawer
                :title="groupId*1 === 15 ? '请输入入场台次（按照主机厂CEP系统-易损件报表-入场台次填写）' : '请输入综合入厂台次（机电+保修+钣喷，不含0工单）'"
                :visible.sync="dialogVisible"
                direction="rtl"
                :wrapperClosable=true
                @close="dialogVisible = false">
            <el-form  label-width="120px" style="height: 300px; ">

                <el-form-item label="日期:">
                    <el-input
                            disabled
                            v-model="waitAddDay"
                            clearable
                    ></el-input>
                </el-form-item>
                <el-form-item
                        :label="groupId*1 === 15 ? '入场台次' : '综合入厂台次'"
                >
                    <el-input
                            :placeholder="groupId*1 === 15 ? '请输入入场台次（按照主机厂CEP系统-易损件报表-入场台次填写）' : '请输入综合入厂台次'"
                            v-model="incomeCarNum"
                            clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="保养基数:">
                    <el-input
                            placeholder="请输入保养基数"
                            v-model="oilFilterBase"
                            clearable
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a @click="ensure" class="sure_btn">确 定</a>
                <a @click="dialogVisible = false" class="cancel_btn">取 消</a>
            </div>
        </el-drawer>


    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import moment from 'moment'
  export default {
    data() {
      return {
        tableHeight: "200",
        groupArr: [],
        groupName: "",
        loginUserOrgId: "",
        orgId: "",
        groupId: 2,
        orgIdArr: [],
        queryMonth: "",
        conditionList: [],
        pickerOptions: {
          disabledDate(time) {
            let year = new Date().getFullYear();
            let month = new Date().getMonth();
            let days = new Date(year, month, 0).getDate();
            const timeDifference = days; // 时间差
            let startDatd = new Date("2019-11").getTime();
            return (
              time.getTime() > Date.now() - timeDifference ||
              time.getTime() < startDatd
            );
          },
        },

        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },
        startDay:'',
        endDay:'',
        dateList:[],

        dialogVisible: false,
        waitAddDay: "",
        incomeCarNum: "",
        oilFilterBase:"",
        activeName: "first",
        queryMonthDayCountData: [],
      };
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));

      this.orgId = signInfo.orgId;

      let obj = new Date();
      let month = obj.getMonth() + 1;
      let lastMonth = month+1 > 12 ? '1' : month+1
      let lastYear = month+1 > 12 ? obj.getFullYear()+1 : obj.getFullYear()
      if (month < 10) month = "0" + month;
      if (lastMonth < 10) lastMonth = "0" + lastMonth;


      this.queryMonth = obj.getFullYear() + "-" + month; // 本月

      this.startDay = obj.getFullYear() + "-" + month + '-01';
      this.endDay = lastYear + "-" + lastMonth + '-01';

      this.queryMonthToDayList()
    },
    methods: {
      onMouseOver(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'none';
        }else {
          this.$refs.iconDateEnd.style.display = 'none';
        }
      },
      onMouseleave(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'block';
        }else {
          this.$refs.iconDateEnd.style.display = 'block';
        }
      },

      //每天进站数量
      queryMonthToDayList() {
        if ( this.startDay === "" || this.startDay === null || this.endDay === null || this.endDay === null ) {
          net.message(this, "请选择查询月份", "warning");
          return;
        }
        this.getEveryDay(this.startDay, this.endDay)
        const params = {
          orgId: this.orgId,
          startDay: this.startDay,
          endDay: this.endDay
        };
        net.request("admin/dossier/inCar/queryDayListByFilter", "post", params, null).then((res) => {
          if (res.retcode === 1) {
            let groupId = res.data.groupId
            let data = res.data.list;
            let result = []; // 未填写的日期数据
            let dateList = this.dateList
            for (let i = 0; i < dateList.length; i++) {
              let obj = dateList[i];
              let num = obj.dayIndex;
              let flag = false;
              for (let j = 0; j < data.length; j++) {
                let aj = data[j];
                let n = aj.dayIndex;
                if (n == num) {
                  flag = true;
                  break;
                }
              }
              if (!flag) {
                result.push(obj);
              }
            }
            let conditionList = data.concat(result);
            this.conditionList = conditionList.sort(this.compareDes("dayIndex"));
            this.groupId = groupId
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
            this.tableHeight = windiwHight - 200;
            this.$nextTick(() => {
              this.$refs["table_day"].doLayout();
            });
          } else {
            net.message(this, res.retmsg, "warning");
          }
        });
      },
      queryMonthDayCount() {
        net.request("admin/dossier/inCar/queryMonthDayCount","post",{ orgId: this.orgId },null).then((res) => {
          if (res.retcode === 1) {
            this.queryMonthDayCountData = res.data;
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
            this.tableHeight = windiwHight - 200;
            this.$nextTick(() => {
              this.$refs["table_month"].doLayout();
            });
          } else {
            net.message(this, res.retmsg, "warning");
          }
        });
      },
      onClickRowButton(data) {
        this.incomeCarNum = "";
        this.waitAddDay = data.dayIndex;
        this.dialogVisible = true;
      },
      ensure() {
        //补录对应日期的进站台次
        if (this.waitAddDay === "" || this.waitAddDay === null) {
          net.message(this, "请刷新后重试", "warning");
          return;
        }
        if (this.incomeCarNum === "" || this.incomeCarNum === null) {
          net.message(this, "输入进站台次", "warning");
          return;
        }
        if (this.incomeCarNum < 0) {
          net.message(this, "进站台次不能小于0", "warning");
          return;
        }
        net
          .request(
            "admin/dossier/inCar/supplementInCarCount",
            "post",
            {
              orgId: this.orgId,
              day: this.waitAddDay,
              inCarCount: this.incomeCarNum,
              oilFilterBase: this.oilFilterBase
            },
            null
          )
          .then((res) => {
            if (res.retcode === 1) {
              this.dialogVisible = false;
              this.searchData();
            } else {
              net.message(this, res.retmsg, "warning");
            }
          });
      },
      handleClick(tab) {
        this.activeName = tab.paneName;
      },
      searchData() {
        let activeName = this.activeName;
        if (activeName === "first") {
          this.queryMonthToDayList();
        } else if (activeName === "second") {
          this.queryMonthDayCount();
        }
      },
      // 排序 降序
      compareDes: function (property) {
        return function (a, b) {
          const value1 = a[property];
          const value2 = b[property];
          return value2 - value1;
        };
      },
      // 排序 升序
      compareAsc: function (property) {
        return function (a, b) {
          const value1 = a[property];
          const value2 = b[property];
          return value1 - value2;
        };
      },

      //查询日期数组
      getEveryDay(startDay, endDay) {
        this.dateList = []
        let SDate=moment(startDay);
        let EDate=moment(endDay);
        this.dateList.push({
          dayIndex:SDate.format("YYYYMMDD"),
          value: "-",
        });
        while( SDate.add(1,"days").isBefore( EDate) ){  // 注意这里add方法处理后SDate对象已经改变。
          this.dateList.push({
            dayIndex:SDate.format("YYYYMMDD"),
            value: "-",
          });
        }
        // this.dateList.push({
        //   dayIndex:EDate.format("YYYYMMDD"),
        //   value: "-",
        // });

        // let start = startDay;
        // let end = endDay;
        // let startTime = this.getDate(start);
        // let endTime = this.getDate(end);
        // this.dateList = [];
        // while ((endTime.getTime() - startTime.getTime()) >= 0) {
        //   let year = startTime.getFullYear();
        //   let month = startTime.getMonth().toString().length == 1 ? "0" + startTime.getMonth().toString() : startTime.getMonth();
        //   let day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
        //   this.dateList.push({
        //     dayIndex: year + "" + month + "" + day,
        //     value: "-",
        //   });
        //   startTime.setDate(startTime.getDate() + 1);
        // }
      },

      getDate(datestr) {
        let temp = datestr.split("-");
        let date = new Date(temp[0], temp[1], temp[2]);
        return date;
      },

    },
  };
</script>


<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin-top: 24px;
        margin-left: 24px;
        .search {
          /*display: flex;*/
          flex-wrap: wrap;
          background: #fff;
          .p_select {
            display: flex;
            padding: 0 0 12px 0;
            font-size: 12px;
            float: left;
            margin-right: 12px;
            .search_label{
              font-family: 'PingFang SC';
              font-style: normal;
              margin-right: 12px;
              font-weight: 500;
              font-size: 14px;
              line-height: 40px;
              color: #787E86;
              white-space:nowrap
            }

            .el-input , .el-select{
              width: 160px;
            }
          }
        }
        .search_btn {
          width: 76px;
          height: 36px;
            line-height: 36px;
          background: #2B54FC;
          box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
          border-radius: 4px;
          color: #FFFFFF;
          font-size: 14px;
        }
        .test_detail {
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            width: 60px;
            height: 24px;
            text-align: center;
            display: block;
            font-weight: 500;
            font-size: 11px;
            line-height: 24px;
            color: #364556;
        }
    }

    .elTableClass th,
    .elTableClass td {
        padding: 0 !important;
        height: 20px; //需要的高度
        line-height: 20px;
    }
    .tab_box_self {
      background: #fff;
      padding-left: 24px;
        padding-right: 24px;
    }

    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
</style>
